import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponseWithPagination,
  GetWhatsappOpeningMessagesSchema,
  WhatsappOpeningMessagesResponseData,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetWhatsappOpeningMessagesSchema>
type Response = DataResponseWithPagination<z.infer<typeof WhatsappOpeningMessagesResponseData>>
type OnSuccessFn = (data: Response) => void

export const getWhatsappOpeningMessagesQueryKey = (query: Query = {}) => [
  "campaignsWhatsappOpeningMessages",
  query,
]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
  enabled?: boolean
}

export const whatsappOpeningMessagesQuery = ({ query, onSuccess, enabled = true }: Props = {}) => {
  return queryOptions({
    queryKey: getWhatsappOpeningMessagesQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/integrations/whatsapp/opening-messages", {
        params: query,
      })
      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
